var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseReassignmentWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H9C7.644 4 6.532 4 5.61 4.054C3.965 4.151 2.922 4.421 2.172 5.172C1 6.343 1 8.229 1 12C1 15.771 1 17.657 2.172 18.828C3.344 19.999 5.229 20 9 20H13C16.771 20 18.657 20 19.828 18.828C20.999 17.656 21 15.771 21 12C21 8.229 21 6.343 19.828 5.172C19.078 4.422 18.035 4.152 16.391 4.054C15.468 4 14.356 4 13 4Z",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60938 4.054C6.43238 4.034 7.15937 3.454 7.43937 2.68L7.47438 2.577L7.49937 2.5C7.54137 2.373 7.56338 2.31 7.58538 2.254C7.72664 1.90281 7.96466 1.59892 8.27179 1.37765C8.57891 1.15638 8.94253 1.02681 9.32037 1.004C9.37937 1 9.44737 1 9.57937 1H12.4174C12.5504 1 12.6174 1 12.6774 1.004C13.0552 1.02681 13.4188 1.15638 13.726 1.37765C14.0331 1.59892 14.2711 1.90281 14.4124 2.254C14.4354 2.31 14.4564 2.374 14.4984 2.5L14.5244 2.577C14.5424 2.63 14.5504 2.657 14.5594 2.68C14.8394 3.455 15.5664 4.034 16.3894 4.054",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6619 6.71973C17.6519 8.67573 16.1469 9.65373 14.5609 10.1467C12.2419 10.8672 9.75888 10.8672 7.43989 10.1467C5.85289 9.65373 4.34789 8.67673 1.33789 6.71973M6.99989 8.99973V10.9997M14.9999 8.99973V10.9997",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseReassignmentWhiteIcon);
export default __webpack_public_path__ + "static/media/CaseReassignmentWhiteIcon.bab4ee7d897305b3442a372d7a73b653.svg";
export { ForwardRef as ReactComponent };